import './loader.css';

interface ILoaderProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  color?: 'primary' | 'success' | 'error' | 'default';
}

const Loader: React.FC<ILoaderProps> = ({ size = 'md', color = 'default' }) => {
  // Set size based on prop
  let _size = '20px';
  switch (size) {
    case 'sm':
      _size = '15px';
      break;
    case 'md':
      _size = '20px';
      break;
    case 'lg':
      _size = '30px';
      break;
    case 'xl':
      _size = '40px';
      break;
  }

  // Set color classes
  let borderColorClass = '';
  switch (color) {
    case 'primary':
      borderColorClass = 'border-ds-brand-mc-blue-1';
      break;
    case 'success':
      borderColorClass = 'border-success';
      break;
    case 'error':
      borderColorClass = 'border-error';
      break;
    default:
      borderColorClass = 'border-white';
      break;
  }

  return (
    <div
      data-testid="custom-loader"
      className={`loader border-4 ${borderColorClass} rounded-full`}
      style={{
        borderTopColor:
          color === 'primary'
            ? '#ffffff'
            : color === 'success'
              ? '#28a745'
              : color === 'error'
                ? '#dc3545'
                : '#D9D9D9',
        borderRightColor:
          color === 'primary'
            ? '#ffffff'
            : color === 'success'
              ? '#28a745'
              : color === 'error'
                ? '#dc3545'
                : '#D9D9D9',
        borderBottomColor:
          color === 'primary'
            ? '#ffffff'
            : color === 'success'
              ? '#28a745'
              : color === 'error'
                ? '#dc3545'
                : '#D9D9D9',
        width: _size,
        height: _size,
      }}
    />
  );
};

export default Loader;
